module.exports = __webpack_public_path__ + "static/img/1-1Z60414150S04.2162476.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z60414150S04.jpg
// module id = oryf
// module chunks = 0